import { render, staticRenderFns } from "./HKLViewLayout.vue?vue&type=template&id=5739493a&"
import script from "./HKLViewLayout.vue?vue&type=script&lang=js&"
export * from "./HKLViewLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5739493a')) {
      api.createRecord('5739493a', component.options)
    } else {
      api.reload('5739493a', component.options)
    }
    module.hot.accept("./HKLViewLayout.vue?vue&type=template&id=5739493a&", function () {
      api.rerender('5739493a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Layout/HKLViewLayout.vue"
export default component.exports